import React, { Component } from "react";
import { connect } from "react-redux";
import ChipsArray from "../ChipsArray";
import { withRouter } from "../../utilities/withRouter";
import { IconGitBranch } from "@tabler/icons-react";

import lxwConstants from "../../config/lexworkplace-constants";
const availableDeveloperOverrides = lxwConstants.availableDeveloperOverrides;

/*
	Displays what values are currently overridden compared
	to the defaults that are configured in the frontend.config.json
	and backend.config.json

	Currently these values must be set manually via the web console
*/

class DeveloperOverrides extends Component {
	constructor(props) {
		super(props);
	}

	render() {
		return (
			<div>
				<ChipsArray
					style={{ justifyContent: "right" }}
					chips={[
						...this.props.enabledDeveloperOverrides.map(
							(
								{
									key: overrideKey,
									shortLabel,
									value,
									fullValueDescription,
									chipClass,
								},
								index
							) => {
								const label =
									overrideKey === "gitBranch" ? (
										<span
											style={{
												display: "flex",
												alignItems: "center",
												gap: 4,
											}}
										>
											<IconGitBranch size={14} />
											{value}
										</span>
									) : (
										shortLabel + " : " + value
									);

								return {
									label,
									key: index,
									style: {
										backgroundColor: "var(--lw-gold)",
										padding: 4,
										"--badge-bd": "none",
									},
									title: `Developer override currently set.  Overriding ${shortLabel} to use ${fullValueDescription}`,
									chipClass,

									handleClick: () => {
										const { history } = this.props;
										history.push("/settings/developer");
									},
								};
							}
						),
					]}
					useSmallChips={true}
				/>
			</div>
		);
	}
}
const mapStateToProps = (state) => {
	return {
		enabledDeveloperOverrides: Object.keys(state.developerOverrides)
			.filter((key) => {
				return state.developerOverrides[key] !== "OVERRIDE_DISABLED";
			})
			.map((enabledKey) => {
				const overrideValue = state.developerOverrides[enabledKey];

				const availableOverride =
					availableDeveloperOverrides[enabledKey];

				const overrideHasAllowedOptions = availableOverride?.options;

				const shortLabel = availableOverride
					? availableOverride.info.shortLabel
					: enabledKey;

				let fullValueDescription = overrideValue;

				if (overrideHasAllowedOptions) {
					fullValueDescription = availableOverride
						? availableOverride.options[overrideValue].display
						: overrideValue;
				}

				let chipClass = null;

				if (enabledKey === "tunnel") {
					chipClass = "pulsing-gold";
					if (overrideValue === "production") {
						chipClass = "pulsing-red";
					}
				}

				return {
					key: enabledKey,
					value: overrideValue,
					shortLabel,
					fullValueDescription,
					chipClass,
				};
			}),
	};
};
export default connect(mapStateToProps, {})(withRouter(DeveloperOverrides));
